import { render, staticRenderFns } from "./PendingContracts.vue?vue&type=template&id=d44e9140&"
import script from "./PendingContracts.vue?vue&type=script&lang=js&"
export * from "./PendingContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports